import React, {useContext} from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom'

import Login from './pages/login/index.jsx'
import Home from './pages/home/index.jsx'
import Order from './pages/order/index.jsx'
import User from './pages/userPage/index.jsx'
import Contracts from './pages/contracts/index.jsx'
import ChatPage from './pages/chatPage/index.jsx'
import LoadContainer from './components/loading/index.jsx'

import { AuthProvider, AuthContext } from './contexts/auth.jsx'
import { Tasks } from './pages/tasks/index.jsx'

const AppRoutes = () => {
  
    const Private = ({children}) => {
        const { authenticated, loading } = useContext(AuthContext)

        if(loading) {
            return <div style={{display:"flex", alignItems:'center', justifyContent:'center', width:100+"vw", height:100 + "vh"}}>
                <LoadContainer/>
                </div>
        }
        return children 
    }

    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route exact path='/' element={<Login/>}/>
                    <Route exact path='/login' element={<Login/>}/>
                    <Route exact path='/home' element={<Private><Home/></Private>}/>
                    <Route exact path='/tasks' element={<Private><Tasks/></Private>}/>
                    <Route exact path='/order' element={<Private><Order/></Private>}/>
                    <Route exact path='/user' element={<Private><User/></Private>}/>
                    <Route exact path='/chat' element={<Private><ChatPage/></Private>}/>
                    <Route exact path='/contracts' element={<Private><Contracts/></Private>}/>
                </Routes>
            </AuthProvider>
        </Router>
    )
}

export default AppRoutes